import { MenuItem } from '@mui/material';

export const LANG_MENU_ITEMS: { key: string; value: string }[] = [
  {
    key: 'fr',
    value: 'Français',
  },
  {
    key: 'en',
    value: 'English',
  },
];

export default function getLangMenuItems() {
  return LANG_MENU_ITEMS.map((lang) => (
    <MenuItem key={lang.key} value={lang.key}>
      {lang.value}
    </MenuItem>
  ));
}
